import { InvoicesTable } from "@/features/invoices/invoices-table";

export function InvoicesScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Invoices</h1>
        <p className="text-gray-600 mt-2">View and manage customer invoices</p>
      </div>
      <InvoicesTable />
    </div>
  );
}
